import Pagination from './Pagination';

export type { IPagination, PaginationType, PaginationStore } from './Pagination.types';

export default Pagination;
export { Pagination };
